export const color1 = `#ff71ce`
export const color2 = `#01cdfe`
export const color3 = `#05ffa1`
export const color4 = `#b967ff`
export const color5 = `#fffb96`